module.exports = "<span data-ng-message=required>*An asset tag is required</span> ";